import { isSlideComponentMC, Question } from '@/types/slide';
import { ResultCardUnsupported } from './ResultCardUnsupported';
import { useTranslation } from 'react-i18next';
import { ResultContainer, ResultContent, ResultTitle } from '../ResultCard';
import { Slide } from '@/components/slides/Slide';
import { Box, Stack, Typography } from '@mui/material';
import { isArray } from '@apollo/client/utilities';
import { isCorrectnessDeterminable } from '@/utils/score';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import React from 'react';

export const ResultCardMC: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    if (!isSlideComponentMC(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    const hasAnswer = question.answers && isArray(question.answers) && question.answers.length > 0;
    const scored = !isCorrectnessDeterminable(question) || question.answers[0]?.correct;

    return (
        <>
            <ResultContainer>
                <ResultTitle variant='h6'>{t('slide.components.mc.title')}</ResultTitle>
                <ResultContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Stack direction={'row'} spacing={2}>
                        <Box>
                            <Typography variant='subtitle2' gutterBottom>
                                {t('result.label.question')}
                            </Typography>
                            <Box sx={{ width: 480, height: 360 }}>
                                <Slide components={[question]} preview={{ answer: true }} />
                            </Box>
                        </Box>
                        <Box>
                            <Typography variant='subtitle2' gutterBottom>
                                {t('result.label.answer')}
                            </Typography>
                            <Box sx={{ width: 480, height: 360 }}>
                                <Slide components={[question]} preview={{ answer: true }} questions={[question]} />
                            </Box>
                        </Box>
                    </Stack>
                </ResultContent>

                <Box
                    sx={(theme) => ({
                        backgroundColor: !hasAnswer ? 'transparent' : scored ? (theme.vars || theme).palette.success.main : (theme.vars || theme).palette.error.main,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        p: 1,
                        borderRadius: '4px',
                    })}
                >
                    {!hasAnswer ? (
                        <Typography variant='h5' color='warning' textAlign={'center'}>
                            {t('result.label.noResult')}
                        </Typography>
                    ) : scored ? (
                        <CheckIcon style={{ color: 'white' }} />
                    ) : (
                        <CloseIcon style={{ color: 'white' }} />
                    )}
                </Box>
            </ResultContainer>
        </>
    );
};
